import { render, staticRenderFns } from "./PostInvoicesDialog.vue?vue&type=template&id=bbd4859a&scoped=true"
import script from "./PostInvoicesDialog.vue?vue&type=script&lang=js"
export * from "./PostInvoicesDialog.vue?vue&type=script&lang=js"
import style0 from "./PostInvoicesDialog.vue?vue&type=style&index=0&id=bbd4859a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd4859a",
  null
  
)

export default component.exports